module.exports = __webpack_public_path__ + "static/media/cta_pattern_bg.4bddfbf0.jpg";